/**
 * Identifier normalization shared by the server and the client.
 *
 * Both display and normalized forms are stored; the normalized form is the
 * lookup and uniqueness key. Login and account uniqueness use
 * {@link normalizeEmail}; the case module uses the VIN, RO, and part-number
 * rules when it arrives.
 */

export const normalizeEmail = (value: string): string => value.trim().toLowerCase();

export const normalizeVin = (value: string): string => value.replace(/[\s-]/g, "").toUpperCase();

export const normalizeRo = (value: string): string =>
  value.trim().replace(/\s+/g, " ").toUpperCase();

export const normalizePartNumber = (value: string): string =>
  value.toUpperCase().replace(/[^A-Z0-9]/g, "");

/** Trims and collapses internal whitespace without changing display case. */
export const normalizeName = (value: string): string => value.trim().replace(/\s+/g, " ");
